module.exports = __webpack_public_path__ + "img/babylon-berlin.eb3fa412.jpg";